import React, { FC, useCallback } from 'react'
import { ProjectSectionDataLogger } from 'src/api'
import { Paper } from '@mui/material'
import {
  DataGridPremium,
} from '@mui/x-data-grid-premium'
import { useSectionDataLoggerColumns } from './useSectionDataLoggerColumns'

export interface SectionDataLoggerRow {
  id: string;
  deviceId: string;
  event: string;
  time: string;
}

interface Event {
  name: string;
  field: keyof ProjectSectionDataLogger;
}

interface Props {
  projectSectionsDataLoggers: ProjectSectionDataLogger[];
}

export const SectionDataLoggerInfo: FC<Props> = ({ projectSectionsDataLoggers }) => {
  const columns = useSectionDataLoggerColumns()
  const rows: SectionDataLoggerRow[] = useCallback(() => {
    const events: Event[] = [
      { name: 'Connected At', field: 'createdAt' },
      { name: 'Disconnected At', field: 'disconnectedAt' },
    ]
    const _rows: SectionDataLoggerRow[] = []
    events.forEach((event) => {
      projectSectionsDataLoggers.forEach((psdl) => {
        _rows.push({
          id: `${event.field}_${psdl.id}`,
          event: event.name,
          deviceId: psdl.dataLogger?.deviceId || '',
          time: (psdl[event.field] || '') as string
        })
      })
    })
    return _rows
  }, [projectSectionsDataLoggers])()
  return (
    <Paper sx={{ flexGrow: 1 }}>
      <DataGridPremium<SectionDataLoggerRow>
        autoHeight
        rows={rows}
        columns={columns}
        rowThreshold={2}
        columnThreshold={2}
        disableRowSelectionOnClick
        localeText={{
          columnMenuSortAsc: "Sort A-Z",
          columnMenuSortDesc: "Sort Z-A",
        }}
        sx={(theme) => ({
          border: "none",
          "& .MuiDataGrid-columnHeaderTitleContainerContent": {
            paddingLeft: "5px",
            overflow: "visible",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: 1,
            fontSize: "13px",
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.6)",
            overflow: "visible",
          },
        })}
      />
    </Paper>
  )
}
